import toLower from "lodash/toLower";
import snakeCase from "lodash/snakeCase";

import { NON_WORK_EMAILS_REGEX, VALID_EMAIL_FILTER_REGEX } from "./constants";

export const splitMailList = (data) => {
  const regex = /[,;\n]+/gi;
  const emails = data.split(regex).filter((elem) => !regex.test(elem));
  return emails;
};

export const getValidInvalidEmails = (emailList = []) => {
  return emailList.reduce(
    (res, elem) => {
      elem = elem.trim().replace(/^[\n]+$/gi, "");
      if (VALID_EMAIL_FILTER_REGEX.test(elem)) {
        const matches = (elem.match(VALID_EMAIL_FILTER_REGEX) || []).map(toLower);
        res.validEmails.push(...matches);
      } else if (elem) {
        res.invalidEmails.push(elem);
      }
      return res;
    },
    { validEmails: [], invalidEmails: [] },
  );
};

export const getSelectDropdownMapping = ({ data = [], keyAttr = "id" }) => {
  const dataMapping = data.reduce((acc, dataObj) => {
    acc[dataObj[keyAttr]] = { ...dataObj };
    return acc;
  }, {});
  return dataMapping;
};

export const isNotWorkEmail = (value) => {
  const res = value.toString().match(NON_WORK_EMAILS_REGEX);
  return res !== null;
};

export const getFirstAndLastName = (fullName) => {
  const parts = fullName.trim().split(" ");
  const partsLength = parts.length;
  const firstName = parts[0] || ".";
  const lastName = partsLength > 1 ? parts[partsLength - 1] : "."; //Request fails on BE if last_name is empty so sending '.'

  return {
    firstName,
    lastName,
  };
};

export const appendObjectInFormData = ({
  obj = {},
  parentKey = "",
  data,
  snakifyKeys = true,
  transformNullValue = false,
}) => {
  Object.entries(obj).forEach(([key, value]) => {
    const isValueObj = Boolean(value && typeof value === "object");
    const isIteratingArray = Array.isArray(obj);
    const keyName = snakifyKeys && !key?.startsWith("_") ? snakeCase(key) : key;
    const propName = isIteratingArray ? "" : keyName;
    const isAttachment = [File, Blob].includes(value?.constructor);

    const newKey = `${parentKey}[${propName}]${isAttachment ? "[attachment]" : ""}`;
    if (!isAttachment && isValueObj && !isIteratingArray) {
      return appendObjectInFormData({
        parentKey: newKey,
        obj: value,
        data,
        snakifyKeys,
      });
    }
    const newValue = (() => {
      if (isIteratingArray) {
        return JSON.stringify(value);
      }
      if (value === null && transformNullValue) {
        return undefined;
      }
      return value;
    })();
    if (typeof newValue !== "undefined") {
      data.append(newKey, newValue);
    }
  });
};

export const getValidInvalidHashtags = ({ list = [], regex }) => {
  return list.reduce(
    (res, elem) => {
      elem = elem.trim().replace(/^[\n]+$/gi, "");
      if (regex.test(elem)) {
        const matches = (elem.match(regex) || [])[0];
        res.validList.push(matches);
      } else if (elem) {
        res.invalidList.push(elem);
      }
      return res;
    },
    { validList: [], invalidList: [] },
  );
};

export const withSkipContacts = (payload) => {
  if (payload instanceof FormData) {
    if (!payload.has("skip_contacts")) {
      payload.append("skip_contacts", "true");
    }
    return payload;
  }

  return { skip_contacts: true, ...payload };
};
